import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../services/firebase";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_LOYALTY_REWARDS_TABLE } from "../../../constants/FirebaseConstants";

export function useLoyaltyRewards() {
  const { data } = useSWRSubscription("loyaltyRewards", (key, { next }) => {
    const q = query(
      collection(db, FIRESTORE_LOYALTY_REWARDS_TABLE),
      orderBy("points"),
    );
    return onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      next(null, data);
    });
  });

  return {
    data,
    loading: !data,
  };
}
